import r from 'render-dom';

import Skeleton from 'components/App/Dashboard/ui/Skeleton';
import Card from 'components/ui/Card';
import CardSection from 'components/shared/Card/Section';

const style = {
    container: {
        background: '#FFFFFF',
        cursor: 'pointer',
        position: 'relative'
    },
    productCard: {
        position: 'relative',
    },
    productInfo: {
        overflow: 'hidden',
        paddingLeft: 20,
    },
    productRank: {
        display: 'flex',
        justifyContents: 'space-between',
    },
    productSection: {
        alignItems: 'center',
        display: 'flex',
    },
    rankInfo: {
        marginTop: 20
    },
    rankInfoItem: {
        flex: 1,
        paddingLeft: 5,
        paddingRight: 5,
    },
    rankInfoItemSeparator: {
        borderLeft: '1px solid rgba(0, 0, 0, .15)',
        borderRight: '1px solid rgba(0, 0, 0, .15)',
        flex: 1,
        paddingLeft: 5,
        paddingRight: 5,
    },
};

export default function ProductCardSkeletonLayout() {
    const productCardStyle = {
        border: '2px solid #ffffff',
        marginBottom: 20,
        padding: 20,
    };
    return (
        r(Card, { style: { ...style.productCard, ...productCardStyle } }, [
            r.div({
                style: style.container
            }, [
                r(CardSection, { style: style.productSection }, [
                    r(Skeleton, { height: '49px', width: '49px' }),
                    r.div({ style: style.productInfo }, [
                        r(Skeleton, { height: '33px', margin: '0 0 5px 0', width: '150px' }),
                        r(Skeleton, { height: '14px', width: '96px' }),
                    ]),
                ]),
                r(CardSection, { style: style.rankInfo }, [
                    r.div({ style: style.productRank }, [
                        r.div({ style: style.rankInfoItem }, [
                            r(Skeleton, { height: '17px', margin: '0 auto 2px', width: '19px' }),
                            r(Skeleton, { height: '12px', margin: '0 auto 3px', width: '60px' }),
                        ]),
                        r.div({ style: style.rankInfoItemSeparator }, [
                            r(Skeleton, { height: '17px', margin: '0 auto 2px', width: '19px' }),
                            r(Skeleton, { height: '12px', margin: '0 auto 3px', width: '60px' }),
                        ]),
                        r.div({ style: style.rankInfoItem }, [
                            r(Skeleton, { height: '17px', margin: '0 auto 2px', width: '19px' }),
                            r(Skeleton, { height: '12px', margin: '0 auto 3px', width: '60px' }),
                        ]),
                    ])
                ])
            ])
        ])
    );
}
